// material-ui
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";

// react-router
import PropTypes from "prop-types";

// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

const UpgradePlanCard = ({ onNavigate = undefined }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const backgroundColor = isDarkMode
    ? alpha(theme.palette.primary.main, 0.18)
    : theme.palette.primary.main;

  const ringColor = isDarkMode
    ? alpha(theme.palette.primary.light, 0.4)
    : theme.palette.warning.light;

  const subtitleColor = isDarkMode
    ? alpha(theme.palette.common.white, 0.7)
    : "grey.900";

  const buttonColor = isDarkMode ? "primary" : "white";

  const cardSX = {
    content: '""',
    position: "absolute",
    width: 200,
    height: 200,
    borderColor: ringColor,
  };

  return (
    <Card
      sx={{
        bgcolor: backgroundColor,
        my: 2,
        overflow: "hidden",
        position: "relative",
        "&:after": {
          border: "19px solid ",
          borderRadius: "50%",
          top: "65px",
          right: "-150px",
          ...cardSX,
        },
        "&:before": {
          border: "3px solid ",
          borderRadius: "50%",
          top: "145px",
          right: "-70px",
          ...cardSX,
        },
      }}
    >
      <CardContent>
        <Grid container direction="column" spacing={2}>
          <Grid>
            <Typography variant="h4" color="white">
              Upgrade Your Plan
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="subtitle2" color="white">
              20% discount for annual subscriptions.
            </Typography>
          </Grid>
          <Grid>
            <Stack direction="row">
              <Button
                variant="contained"
                color={buttonColor}
                sx={{
                  boxShadow: "none",
                  // border: `1px solid ${buttonBorderColor}`,
                }}
                onClick={onNavigate}
              >
                Sign Up
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

UpgradePlanCard.propTypes = {
  onNavigate: PropTypes.func,
};

export default UpgradePlanCard;
